import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { startVersionMonitoring, forceReload } from '../utils/versionChecker';

/**
 * Componente che monitora e notifica quando è disponibile una nuova versione dell'app
 */
const VersionChecker = () => {
  const [showModal, setShowModal] = useState(false);
  const [versionInfo, setVersionInfo] = useState(null);

  useEffect(() => {
    // Avvia il monitoraggio delle versioni
    const stopMonitoring = startVersionMonitoring((info) => {
      setVersionInfo(info);
      setShowModal(true);
    });

    // Cleanup
    return () => {
      if (stopMonitoring) {
        stopMonitoring();
      }
    };
  }, []);

  const handleReload = () => {
    forceReload();
  };

  const handleDismiss = () => {
    setShowModal(false);
  };

  return (
    <Modal show={showModal} onHide={handleDismiss} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Nuova versione disponibile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          È disponibile una nuova versione dell'applicazione.
        </p>
        {versionInfo && (
          <div className="small text-muted">
            <div>Versione corrente: {versionInfo.currentVersion}</div>
            <div>Nuova versione: {versionInfo.newVersion}</div>
          </div>
        )}
        <p className="mt-3 mb-0">
          Per utilizzare le nuove funzionalità, è necessario ricaricare la pagina.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleDismiss}>
          Più tardi
        </Button>
        <Button variant="primary" onClick={handleReload}>
          Ricarica ora
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VersionChecker;
